var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('lottie-vue-player',{staticStyle:{"width":"100%","height":"250px"},attrs:{"src":"/animations/file-loading.json","loop":"","autoplay":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }